import React from 'react';
import Home7 from "../../components/lahalle";

const Lahalle = () => {
    return (
            <>
                <Home7 />
            </>
    );
};

export default Lahalle;
